module.exports = __webpack_public_path__ + "img/FPT10.f45c0fca.svg";